import { Link } from "react-router-dom";
import { SITE } from "../site";

const Logo = ({ dark = false }) => (
    <Link
        to="/"
        data-testid="brand-logo"
        className="flex items-center gap-2.5 group"
        aria-label="SahiKhoj home"
    >
        <span className="relative flex h-9 w-9 items-center justify-center rounded-xl bg-ink transition-transform duration-300 group-hover:rotate-12">
            <span className="h-4 w-4 rounded-full border-[2.5px] border-saffron" />
            <span className="absolute right-1.5 top-1.5 h-1.5 w-1.5 rounded-full bg-leaf" />
        </span>
        <span
            className={`font-display text-xl font-semibold tracking-tight ${
                dark ? "text-cream" : "text-ink"
            }`}
        >
            Sahi<span className="text-saffron">Khoj</span>
        </span>
        <span className="sr-only">{SITE.tagline}</span>
    </Link>
);

export default Logo;
